import { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import { BasicDialog, IFormDialogProps } from '../../../../../components/Dialog/BasicDialog';
import { FormFieldsContainer } from '../../../../../components/Form/FormComponents';
import { RequestsCompaniesList } from '../UnsentKpiRequestsGrid';
import { MaxModalFormHeight, MaxModalFormWidth } from '../../../../../constants/styles';
import { IKPIRequestDataModel } from '../../../../../data-models/kpi-requests.data-model';

interface IRequestFailDialogProps extends IFormDialogProps {
  requests: IKPIRequestDataModel[];
  onClose: () => void;
  title: string;
  message?: string;
}

export const RequestFailDialog: FC<IRequestFailDialogProps> = ({
  open,
  onClose,
  requests,
  title,
  message,
}) => {
  return (
    <BasicDialog open={open} onClose={onClose} titleComponent={<Typography variant='h6'>{title}</Typography>}>
      <FormFieldsContainer
        style={{ maxWidth: MaxModalFormWidth, width: '60rem', maxHeight: MaxModalFormHeight }}
      >
        <Stack display='grid' alignContent='start' gap='1rem' py='0.5rem'>
          <Typography variant='body2' color='textSecondary'>
            {message}
          </Typography>
          <RequestsCompaniesList selectedRows={requests} />
        </Stack>
      </FormFieldsContainer>
    </BasicDialog>
  );
};
